import { format } from "date-fns";
import type { KomboApplicationStageTransitionRequest } from "../api";
import { KomboApplicationStageTransition } from "./kombo_application_stage_transition";

export class KomboApplicationStageTransitions extends Array<KomboApplicationStageTransition> {
  constructor(transitions?: KomboApplicationStageTransition[]) {
    super();
    if (transitions instanceof Array)
      transitions.forEach((transition) => this.push(transition));
  }

  get is_default_transition(): boolean {
    return false;
  }

  get local_last_updated_at(): Date | undefined {
    return this.length === 0
      ? undefined
      : this.map((transition) => transition.local_updated_at).sort(
          (a, b) => b.getTime() - a.getTime(),
        )[0];
  }

  get local_last_updated_at_datetime_string(): string | undefined {
    if (!this.local_last_updated_at) return undefined;
    return format(this.local_last_updated_at, "MMM d, hh:mm aaa");
  }

  toRequest(): Array<KomboApplicationStageTransitionRequest> {
    return this.map((transition) => transition.toRequest());
  }
}
